import { createContext, useContext, type ReactNode } from 'react'
import {
  DEFAULT_PRODUCT_PRICING_CONTEXT,
  type ProductPricingContext,
} from '@/lib/pricing'

const PricingContext = createContext<ProductPricingContext>(DEFAULT_PRODUCT_PRICING_CONTEXT)

interface PricingProviderProps {
  value: ProductPricingContext
  children: ReactNode
}

export function PricingProvider({ value, children }: PricingProviderProps) {
  return (
    <PricingContext.Provider value={value}>
      {children}
    </PricingContext.Provider>
  )
}

export const usePricingContext = () => useContext(PricingContext)
